var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVector = function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.136a5.93 5.93 0 0 0-1.659-4.146 5.557 5.557 0 0 0-3.869-1.717c-.014 0-.028 0-.042-.003H2.703L4.569 1.34a.806.806 0 0 0 0-1.11.744.744 0 0 0-1.072 0L.222 3.617a.806.806 0 0 0 0 1.11l3.272 3.387a.742.742 0 0 0 1.073 0 .81.81 0 0 0 0-1.11l-1.993-2.06h6.76c2.234 0 4.05 1.88 4.05 4.191 0 2.312-1.816 4.192-4.05 4.192H3.697c-.446 0-.808.374-.808.836 0 .461.362.836.808.836H9.36a5.552 5.552 0 0 0 3.983-1.717A5.938 5.938 0 0 0 15 9.136Z",
    fill: "#fff"
  })));
};

export default SvgVector;